module.exports = __webpack_public_path__ + "img/divider.8bc6bb91.svg";